import React from 'react'

import { useHistory } from 'react-router-dom'
import { RHFInput } from 'react-hook-form-input'
import useForm from 'react-hook-form'

import {
  Button,
  Card,
  LinearProgress,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core'

import { CheckCircleOutlineOutlined } from '@material-ui/icons'

import logo from 'images/yapay.svg'
import { routes } from 'routes'
import * as service from 'service'
import styles from './styles'
import schemas from './schemas'
import useSnackbar from 'hooks/useSnackbar'

const useStyles = makeStyles(styles)

const ViewSuccess = () => {
  const classes = useStyles()

  return (
    <>
      <img alt="Logo" src={logo} width="100%" className={classes.logo} />

      <Card className={classes.card}>
        <div className={classes.successContainer}>
          <CheckCircleOutlineOutlined
            color="action"
            className={classes.successIcon}
          />
          <Typography variant="h4" align="center" className={classes.title}>
            Sucesso!
          </Typography>
          <Typography
            variant="subtitle2"
            align="center"
            className={classes.subTitle}
          >
            Sua senha foi alterada com sucesso, aguarde um momento enquanto
            redirecionamos você para a tela de login
          </Typography>
        </div>
      </Card>
    </>
  )
}

export const PasswordChange = ({ match }) => {
  const classes = useStyles()
  const history = useHistory()
  const snackbar = useSnackbar()
  const resetPasswordToken = match.params.token

  const { register, setValue, errors, handleSubmit } = useForm({
    validationSchema: schemas.passwordChange,
    defaultValues: {
      password: '',
      passwordConfirmation: '',
    },
  })

  const [loading, setLoading] = React.useState(false)
  const [success, setSuccess] = React.useState(false)

  const onSubmit = async data => {
    setLoading(true)

    try {
      await service.recurrence.auth.redefinePassword({
        resetPasswordToken,
        ...data,
      })

      setSuccess(true)

      setTimeout(() => {
        history.push(routes.root)
      }, 5000)
    } catch (error) {
      if (error && error.response && error.response.status === 400) {
        snackbar.open({
          message: 'Não foi possível recuperar a senha! Tente novamente!',
          variant: 'error',
        })

        return
      }

      snackbar.open({
        message: 'Ocorreu algum erro! Tente novamente!',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  if (success) {
    return <ViewSuccess />
  }

  return (
    <>
      <img alt="Logo" src={logo} width="100%" className={classes.logo} />

      <form onSubmit={handleSubmit(onSubmit)}>
        <Card className={classes.card}>
          {loading && <LinearProgress className={classes.progress} />}

          <div className={classes.subTitle}>
            <Typography variant="subtitle2" align="center" gutterBottom>
              Cadastre uma nova senha para acesso ao portal com no mínimo 6
              dígitos.
            </Typography>

            <Typography variant="subtitle2" align="center">
              <strong>Dica:</strong> senhas com números, letras e caracteres
              especiais combinados costumam ser mais seguras.
            </Typography>
          </div>

          <div className={classes.fields}>
            <RHFInput
              as={
                <TextField
                  label="Senha"
                  type="password"
                  variant="outlined"
                  disabled={loading}
                  error={!!errors.password}
                  helperText={errors.password && errors.password.message}
                  fullWidth
                />
              }
              register={register}
              setValue={setValue}
              name="password"
              mode="onChange"
            />

            <RHFInput
              as={
                <TextField
                  label="Confirme a senha"
                  type="password"
                  variant="outlined"
                  margin="normal"
                  disabled={loading}
                  error={!!errors.passwordConfirmation}
                  helperText={
                    errors.passwordConfirmation &&
                    errors.passwordConfirmation.message
                  }
                  fullWidth
                />
              }
              register={register}
              setValue={setValue}
              name="passwordConfirmation"
              mode="onChange"
            />
          </div>

          <Button
            variant="contained"
            color="primary"
            type="submit"
            size="large"
            fullWidth
            disabled={loading}
          >
            {loading ? 'Carregando...' : 'Continuar'}
          </Button>
        </Card>
      </form>
    </>
  )
}

export default PasswordChange
